<template>
  <div class="serve-box">
    <div class="line"></div>
    <h1 class="title">{{ cardInfo.title }}</h1>
    <p class="text">{{ cardInfo.text }}</p>
  </div>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.serve-box {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(50% - 30px);
  padding: 28px 48px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 2px 7px 1px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  margin-right: 60px;
  margin-bottom: 40px;
  &:nth-of-type(2n) {
    margin-right: 0;
  }
  @include mobile {
    width: 100%;
    margin-bottom: 16px;
    margin-right: 0;
    padding: 8px 12px;
  }

  .line {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 4px;
    background: $primary1;
    border-radius: 5px 5px 0 0;
    @include mobile {
      height: 3px;
    }
  }

  .title {
    font-size: 20px;
    font-weight: 500;
    color: $font-color1;
    margin-bottom: 20px;
    @include limit-line-numbers(1);
    @include mobile {
      font-size: 16px;
      margin-bottom: 4px;
    }
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    color: $font-color2;
    @include limit-line-numbers(3);
    @include mobile {
      font-size: 12px;
      line-height: 1.4;
    }
  }
}
</style>
